import styled from 'styled-components';
import brandConfig from '../config/brand';
import { useSelector } from 'react-redux';
import { authSelector } from '../modules/auth/state/authSlice';
import { Link } from 'react-router-dom';
import { BackIcon } from '../assets/icons/back';

type PageContainerProps = {
  title: string;
  children: React.ReactNode;
  onGoBack?: string;
};

export const PageContainer = ({ title, children, onGoBack }: PageContainerProps) => {
  const { token } = useSelector(authSelector);
  const isAuthenticated = Boolean(token);
  return (
    <Container>
      {!isAuthenticated && (
        <LogoWrapper>
          <Link to="/">
            <Logo src={brandConfig.logo} alt={`${brandConfig.displayName} logo`} />
          </Link>
        </LogoWrapper>
      )}

      <TopTitle>
        {onGoBack && (
          <StyledLink to={onGoBack}>
            <BackIcon size={20} />
          </StyledLink>
        )}
        <Title>{title}</Title>
      </TopTitle>
      {children}
    </Container>
  );
};

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
`;

const TopTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
`;

const Logo = styled.img`
  width: 5rem;
`;

const Title = styled.h2`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.large};
`;

const Container = styled.div`
  border-radius: 0.5rem;
  width: 100%;
  padding: 1rem;
  padding-top: 0;
  min-height: calc(100vh - 2rem);

  @media (max-width: 850px) {
    padding-bottom: 8rem;
  }
`;
